module.exports = __webpack_public_path__ + "static/media/agent.9abdb75d.jpg";